import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getEvaluationTypeList = store => store[NAME].evaluationTypeList;
export const getFormList = store => store[NAME].formList;
export const getScoreTypeList = store => store[NAME].scoreTypeList;
export const getObjectivePeriodList = store => store[NAME].objectivePeriodList;
export const getCheckCollaboratorsData = store => store[NAME].checkCollaboratorsData;
export const getStatusList = store => store[NAME].statusList;